// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"20f79277","99":"c0e65b19","281":"20f79277","320":"58ce5c47","323":"95c9aa6f","350":"20f79277","489":"20f79277","945":"5ef3a9bf"}[chunkId] + ".css";
};